import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import AppContext from "./contexts/app";
import PluginsContext, { PluginsValue } from "./contexts/plugins";
import UserContext from "./contexts/user";
import ApisContext from "./contexts/apis";
import WebhooksContext from "./contexts/webhooks";
import TypesContext from "./contexts/types";
import DatabaseContext from "./contexts/database";
import LoadingContext from "./contexts/loader";
import ErrorsContext from "./contexts/errors";
import StylesContext from "./contexts/styles";
import Canvas from "./pages/canvas";
import Data from "./pages/data";
import Settings from "./pages/settings";
import Connections from "./pages/connections";
import Styles from "./pages/styles";
import NavBar from "./navbar";
import Auth from "./pages/auth";
import Home from "./pages/home";
import Plugins from "./pages/plugins";
import Preview from "./pages/preview";
import { QueryClient, QueryClientProvider } from "react-query";
import { auth } from "./firebase";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe(
  "pk_live_51HfC3sBLTRLftxZQ2Twn37YlwXLNoq6C5AabO5xuW1bhh3oNIHu14lwMmalEsdXZOpbhXL4A9xKg1Ej7lfyBFUn100plL53yee"
);

const queryClient = new QueryClient();
window.React = React;
window.ReactDOM = ReactDOM;
ReactDOM.render(
  <UserContext>
    <Elements stripe={stripePromise}>
      <LoadingContext>
        <Router>
          <Switch>
            <Route path="/auth">
              <Auth />
            </Route>
            <Route path="/home">
              <Home />
            </Route>
            <Route path="/:appId/preview/:pageId">
              <Preview />
            </Route>

            <Route path="/:appId/:tab?/:type?/:pageId?">
              <ErrorsContext>
                <AppContext>
                  <PluginsContext>
                    <DatabaseContext>
                      <ApisContext>
                        <WebhooksContext>
                          <TypesContext>
                            <StylesContext>
                              <QueryClientProvider client={queryClient}>
                                <NavBar />
                                <React.StrictMode>
                                  <Switch>
                                    <Route path="/:appId/canvas/:type?/:pageId?">
                                      <Canvas />
                                    </Route>
                                    <Route path="/:appId/database/:table?">
                                      <Data />
                                    </Route>
                                    <Route path="/:appId/connections">
                                      <Connections />
                                    </Route>
                                    <Route path="/:appId/styles">
                                      <Styles />
                                    </Route>
                                    <Route path="/:appId/plugins">
                                      <Plugins />
                                    </Route>
                                    <Route path="/:appId/settings">
                                      <Settings />
                                    </Route>
                                  </Switch>
                                </React.StrictMode>
                              </QueryClientProvider>
                            </StylesContext>
                          </TypesContext>
                        </WebhooksContext>
                      </ApisContext>
                    </DatabaseContext>
                  </PluginsContext>
                </AppContext>
              </ErrorsContext>
            </Route>
            <Route path="/">
              <App />
            </Route>
          </Switch>
        </Router>
      </LoadingContext>
    </Elements>
  </UserContext>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
